import React from 'react'
import LabelComponent from '@components/label'
import * as styles from './Label.module.scss'

const Label = (props) => <LabelComponent className={styles.label} {...props} />

export default Label
